import { useEffect } from 'react';
import { usePrevious } from '../usePrevious';
// Runs a callback whenever componentViewMode changes from non-preview to preview
export function usePreviewEffect({ componentViewMode, onPreviewViewMode, }) {
    const previousViewMode = usePrevious(componentViewMode);
    useEffect(() => {
        if (previousViewMode !== 'preview' && componentViewMode === 'preview') {
            onPreviewViewMode?.();
        }
    }, [previousViewMode, onPreviewViewMode, componentViewMode]);
}
//# sourceMappingURL=usePreviewEffect.js.map